import { createApi } from '@reduxjs/toolkit/query/react';

import { ICommunity } from '../../types/interfaces/community';
import { IExercise } from '../../types/interfaces/exercise';
import { IRole } from '../../types/interfaces/role';
import { IUser } from '../../types/interfaces/user';
import { HTTP_METHOD } from '../constants';
import * as endpoints from '../endpoints';
import {
  TransformedErrorResponseWithNotification,
  getBaseQuery,
} from '../generic';

export const searchApi = createApi({
  reducerPath: 'searchApi',
  tagTypes: [],
  baseQuery: getBaseQuery(),
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getGlobalSearchApi: builder.query<
      { exercises: IExercise[]; users: IUser[]; communities: ICommunity[] },
      {
        searchValue: string;
        limit: number;
      }
    >({
      keepUnusedDataFor: 0,
      query({ searchValue, limit }) {
        return {
          url: `${endpoints.Search.ROOT}${endpoints.Search.GLOBAL}?searchValue=${searchValue}&limit=${limit}`,
          method: HTTP_METHOD.GET,
        };
      },
      ...TransformedErrorResponseWithNotification(),
    }),
  }),
});

export const { useLazyGetGlobalSearchApiQuery: useLazyGetGlobalSearch } =
  searchApi;
